export default {
      id: "lock-usage",
      viewBox: "0 0 512 512",
      url: "../../assets/" + "sprite.svg#lock-usage",
      toString: function () {
        return this.url;
      }
    }